import { keyframes } from "styled-components";

export const shadowLoad = keyframes`
to {
  background-position: 315px 0, 0 0, 0 190px, 50px 195px;
}
`;